import Products from '../features/products/Components/Products'

const ProductsPage = () => {
  document.title = "Products Page"
  return (
    <Products />
  )
}

export default ProductsPage